import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { View, Icon, Table, TableColumnOpcoes, TableSearch } from '@components';
import { getVersoes, getVersaoConectores, deleteVersao, setVersaoSelecionadaTela, downloadVersao } from '@ducks/conectoresVersoes';
import styled from 'styled-components';
import { formatDate } from '@utils';

const ViewDs = styled(View)`
  white-space: pre-line;
`;

const ViewDataVersao = styled(View)`
  font-size: 12px;
`;

export default function TableVersoes() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const versoes = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('versoes').toArray());
  const nrBuildSelecionado = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('nrBuildSelecionado'));
  const loadingVersoes = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('loadingVersoes'));

  const handleSearch = () => {
    return dispatch(getVersoes());
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const excluirVersao = (nrBuild) => {
    dispatch(deleteVersao(nrBuild));
  };

  const getVersao = (nrBuild) => {
    dispatch(setVersaoSelecionadaTela(nrBuild));
    dispatch(getVersaoConectores(nrBuild));
  };

  const handleDownloadVersao = ({ nrBuild, jobConector, versao }) => {
    dispatch(downloadVersao(nrBuild, jobConector, versao));
  };

  const columns = [
    {
      title: 'Versão',
      dataIndex: 'versao',
      key: 'versao',
      width: '15%',
      align: 'center',
      render: (text, item) => (
        <View>
          <View>
            <strong>{text}</strong>
          </View>
          <ViewDataVersao>{formatDate(item.dtPublicacao)}</ViewDataVersao>
        </View>
      ),
    },
    {
      title: 'Descrição',
      dataIndex: 'ds',
      key: 'dt',
      width: '65%',
      ...TableSearch('ds', 'descrição', { st1, setSt1, st2, setSt2 }),
      render: (text) => <ViewDs>{text}</ViewDs>,
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '20%',
      render: (text, item) => (
        <TableColumnOpcoes>
          {item.ultimaVersao && (
            <Icon.Default
              type='download'
              hoverBgColor='#6200EE'
              hoverColor='#FFFFFF'
              customIcon={Icon.CloudDownloadOutlined}
              tooltipTitle={`Download da versão v${item.versao}`}
              action={() => handleDownloadVersao(item)}
            />
          )}
          <Icon.Edit action={() => history.push(`/conectores/versao/${item.nrBuild}`)} />
          <Icon.Delete popConfirmTitle={`Deseja excluir a versão ${item.versao}?`} action={() => excluirVersao(item.nrBuild)} />
          {item.nrBuild === nrBuildSelecionado ? (
            <Icon.Selected />
          ) : (
            <Icon.Detail action={() => getVersao(item.nrBuild)} tooltipTitle='Selecionar' />
          )}
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey='id' columns={columns} dataSource={versoes} loading={loadingVersoes} hidePagination />;
}
